/**
 * Quyền web admin. Chủ (isOwner) vào được mọi trang; người được phân quyền chỉ vào được trang có
 * `permission` nằm trong danh sách quyền của họ. Trang không khai báo `permission` chỉ chủ vào được.
 * Máy chủ cũng chặn y hệt, ẩn ở đây chỉ để giao diện gọn.
 */

export const PERMISSIONS = {
  SERVER_VIEW: "server.view",
  SERVER_CONTROL: "server.control",
  ERROR_VIEW: "error.view",
  ERROR_EDIT: "error.edit",
  PLAYER_VIEW: "player.view",
  PLAYER_MODERATE: "player.moderate",
  PLAYER_GIVE: "player.give",
  PLAYER_ACCOUNT: "player.account",
  PETCOIN_GIVE: "petcoin.give",
  PAYMENT_VIEW: "payment.view",
  PAYMENT_TEST: "payment.test",
  PAYMENT_EDIT: "payment.edit",
  PAYMENT_RESOLVE: "payment.resolve",
  MAIL_VIEW: "mail.view",
  MAIL_SEND: "mail.send",
  TASK_VIEW: "task.view",
  TASK_EDIT: "task.edit",
  BOSS_VIEW: "boss.view",
  BOSS_EDIT: "boss.edit",
  BOSS_GIFT: "boss.gift",
  BROADCAST_VIEW: "broadcast.view",
  BROADCAST_SEND: "broadcast.send",
  CHAT_VIEW: "chat.view",
  CHAT_EDIT: "chat.edit",
  GIFTCODE_VIEW: "giftcode.view",
  GIFTCODE_EDIT: "giftcode.edit",
  BALANCE_VIEW: "balance.view",
  BALANCE_EDIT: "balance.edit",
  RATE_VIEW: "rate.view",
  RATE_EDIT: "rate.edit",
  SIMULATE_VIEW: "simulate.view",
  TEMPLATE_VIEW: "template.view",
  TEMPLATE_EDIT: "template.edit",
  HISTORY_VIEW: "history.view",
  CLAN_VIEW: "clan.view",
  CLAN_EDIT: "clan.edit",
  MARKET_VIEW: "market.view",
  MARKET_EDIT: "market.edit",
  TOP_VIEW: "top.view",
  SHOP_VIEW: "shop.view",
  SHOP_EDIT: "shop.edit",
  EVENT_VIEW: "event.view",
  EVENT_EDIT: "event.edit",
  EVENT_RECHARGE: "event.recharge",
  ARENA_VIEW: "arena.view",
  ARENA_EDIT: "arena.edit",
  ARENA_EVENT_VIEW: "arenaevent.view",
  ARENA_EVENT_EDIT: "arenaevent.edit",
  TOWER_VIEW: "tower.view",
  TOWER_EDIT: "tower.edit",
  WORLD_BOSS_VIEW: "worldboss.view",
  WORLD_BOSS_EDIT: "worldboss.edit",
  VIP_VIEW: "vip.view",
  VIP_EDIT: "vip.edit",
  LUCKY_WHEEL_VIEW: "luckywheel.view",
  LUCKY_WHEEL_EDIT: "luckywheel.edit",
  CHECKIN_VIEW: "checkin.view",
  CHECKIN_EDIT: "checkin.edit",
  COLLECTION_VIEW: "collection.view",
  COLLECTION_EDIT: "collection.edit",
  PET_EVOLVE_VIEW: "petevolve.view",
  PET_EVOLVE_EDIT: "petevolve.edit",
  AUTO_VIEW: "auto.view",
  AUTO_EDIT: "auto.edit",
};

export function hasPermission(admin, permission) {
  if (!admin) return false;
  if (admin.isOwner) return true;
  return Boolean(permission) && (admin.permissions || []).includes(permission);
}

export function canOpenRoute(admin, route) {
  return hasPermission(admin, route.permission);
}

/** Lọc thanh bên: bỏ trang không được vào, bỏ tiêu đề / đường kẻ không còn mục nào phía sau. */
export function visibleRoutes(routes, admin) {
  const allowed = routes.filter(
    (route) => route.type === "title" || route.type === "divider" || canOpenRoute(admin, route)
  );
  return allowed.filter((route, index) => {
    if (route.type !== "title" && route.type !== "divider") return true;
    const next = allowed.slice(index + 1).find((r) => r.type !== "title" && r.type !== "divider");
    return Boolean(next) && next.type === "collapse";
  });
}

/** Trang đầu tiên trên thanh bên mà tài khoản vào được, null nếu không có. */
export function homeRoute(routes, admin) {
  const route = routes.find((r) => r.type === "collapse" && canOpenRoute(admin, r));
  return route ? route.route : null;
}
